<template>
    <div>
        <section class="probootstrap-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h4>提供专属健康服务和解决方案</h4>
                        <div class="applyBtn" @click="handleShowConnection">企业客户咨询
                            <img class="iconrTextWhite" src="../assets/common/ic_white.png" /></div>
                    </div>
                </div>
            </div>
            <div style="display: none;"  class="container">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h4>联系合作</h4>
                    </div>
                </div>
            </div>
            <div style="display: none;" class="container">
                <div class="row text-center">
                    <div class="col-md-4">
                        <img src="../assets/common/cop1.png"/>
                        <h5>智能手表报价表</h5>
                        <p>申请智能手表报价表、健康合作</p>
                        <div @click="handleShowConnection">立即申请</div>
                    </div>
                    <div class="col-md-4">
                        <img src="../assets/common/cop2.png"/>
                        <h5>免费申请APP</h5>
                        <p>免费申请app、系统体验账号、API文档</p>
                        <div @click="handleShowConnection">免费申请</div>
                    </div>
                    <div class="col-md-4">
                        <img src="../assets/common/cop3.png"/>
                        <h5>产品合作</h5>
                        <p>平台运营、产品销售合作</p>
                        <div @click="handleShowConnection">合作申请</div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "cooperationCom",
        methods:{
            handleShowConnection(){
                this.$emit('return',true)
            }
        }
    }
</script>

<style scoped>
    .probootstrap-section{
        background: rgba(221,228,247,0.6);
        background: url('../assets/cooperation/bg.png') center center no-repeat;
        background-size: 100% 100%;
        min-height:450px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    h4{
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 50px;
        margin-bottom: 53px;
    }
    .applyBtn{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 28px;
        padding: 16px 27px;
        cursor: pointer;
        background: #005EF0;
        border-radius: 10px;
    }
   
    .col-md-4 img{
        height: 100px;
    }
    .col-md-4 h5{
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 28px;
    }
    .col-md-4 p{
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
    }
    .col-md-4 div{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 180px;
        height: 50px;
        background: #005EF0;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 25px;
        cursor: pointer;
    }
</style>
